export default "__VITE_ASSET__DxuMkbXT__"